export const translationNotFound_da = {
  notFoundTitle: "Siden blev ikke fundet",
  notFoundDescription:
    "Linket kan være ændret eller udløbet. Brug navigationen eller gå tilbage til forsiden.",
  notFoundHomeLink: "Gå til forsiden",
};
